import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import debounce from "lodash.debounce";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import SimpleBackdrop from "utils/general";
import { CommonConfig } from "CommonConfig";
import moment from "moment";
import ReactToPrint from "react-to-print";
import Barcode from "react-barcode";
import ReactDOM from "react-dom";
import PrintDialog from "components/Dialog/PrintDialog";
import ZebraPrinterWidget from "views/Master/Printer";

const Manufacturing = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [manufacturingList, setManufacturingList] = useState([]);
  const [manufacturingId, setManufacturingId] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [manufacturingData, setManufacturingData] = useState({});
  const [productList, setProductList] = useState([]);
  const [barcodeData, setBarcodeData] = useState([]);
  const [barcodeConfig, setBarcodeConfig] = useState([]);
  const [manufacturingPrintId, setManufacturingPrintId] = useState("");
  const [content, setContent] = useState({
    header: "",
    footer: "",
    image: "",
  });
  const [templateHtml, setTemplateHtml] = useState("");
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [printData1, setPrintData1] = useState("");
  const zebraWidgetRef = useRef(null);
  const printButtonRef = useRef(null);
  const componentRef = useRef(null);

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      setUserPageAccess(access);
      fetchManufacturingList(data);
      GetProductMaster(data);
      GetBarcodeConfigurationByConfigName(data);
      GetImageConfiguration(data);
      if (props.location?.state && props.location.state.ManufacturingId) {
        setManufacturingPrintId(props.location.state.ManufacturingId);
      }
    } else {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    debouncedSearch(userId, search);
  }, [search]);

  useEffect(() => {
    if (productList.length && barcodeConfig.length) {
      if (manufacturingPrintId) {
        handleOpen("", "Print");
      }
    }
  }, [productList, barcodeConfig]);

  useEffect(() => {
    if (templateHtml && barcodeData.length) {
      // const timeout = setTimeout(() => {
      //   barcodeData.forEach((product, productIdx) => {
      //     [0, 1].forEach((slotIdx) => {
      //       const container = document.getElementById(
      //         `barcode-container-${productIdx}-${slotIdx}`
      //       );
      //       if (container) {
      //         const barcodeElement = document.createElement("div");
      //         container.innerHTML = "";
      //         container.appendChild(barcodeElement);

      //         ReactDOM.render(
      //           <Barcode
      //             value={product.Barcode}
      //             height={60}
      //             width={6}
      //             fontSize={30}
      //           />,
      //           barcodeElement
      //         );
      //       }
      //     });
      //   });

      //   if (printButtonRef?.current) {
      //     printButtonRef.current.click();
      //   }
      // }, 100);

      // return () => clearTimeout(timeout);
      setShowPrintDialog(true);
    }
  }, [templateHtml, barcodeData]);

  const debouncedSearch = useCallback(
    debounce((userId, keyword) => {
      fetchManufacturingList(userId, {}, keyword);
    }, 400),
    []
  );

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setProductList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetBarcodeConfigurationByConfigName = async (UserId) => {
    try {
      setLoading(true);
      let data = {
        UserId,
        ConfigName: "Manufacturing Barcode",
      };
      await api
        .post(APIConstant.path.GetBarcodeConfigurationByConfigurationName, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            setBarcodeConfig(response.Data);
          }
        })
        .catch((err) => {
          console.log({ err });
        });
    } catch (err) {
      console.log({ err });
    }
  };

  const GetImageConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetImageConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp?.success) {
            const image = `${process.env.REACT_APP_NODE_API_ENDPOINT}/document/${resp?.data[0]?.ImagePath}`;
            setContent({
              header: resp?.data[0]?.Header,
              footer: resp?.data[0]?.Description,
              image: image,
            });
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const fetchManufacturingList = async (userId, event = {}, query = "") => {
    setLoading(true);
    const params = {
      UserId: userId,
      page: event.first ? event.first / rowsPerPage : 0,
      limit: event.rows || rowsPerPage,
      Query: query || "",
    };

    try {
      const response = await api.post(
        APIConstant.path.GetManufacturing,
        params
      );
      if (response.Success === 1) {
        setManufacturingList(response.Data);
        setTotalRecords(response.TotalRecords);
        setFirst(event.first || 0);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const GetManufacturingById = async (ManufacturingId) => {
    try {
      let params = {
        UserId: userId,
        ManufacturingId,
      };
      api
        .post(APIConstant.path.GetManufacturingById, params)
        .then(async (response) => {
          if (response.Success === 1) {
            setManufacturingData(response.Data);
            if (response.Data.OutputItems.length) {
              let tempData = [];
              response.Data.OutputItems.map((item) => {
                let product = productList.find(
                  (product) => product.value === item.ItemId
                );
                let expiryDate = "";
                let barcode = "";
                if (product && item.BatchId) {
                  let existingBatch = product.Variant.Batches.find(
                    (batch) => batch._id === item.BatchId
                  );
                  if (existingBatch) {
                    expiryDate = existingBatch.ExpiryDate;
                    barcode = existingBatch.Barcode;
                  }
                } else {
                  expiryDate = moment(response.Data.ManufacturingDate)
                    .add(parseInt(product.LifeSpan || 0), "days")
                    .toDate();
                }
                if (product) {
                  if (product.Variant?.Barcode && !item.BatchId) {
                    barcode = product.Variant.Barcode;
                  }
                  let tempPrice = item.Rate || item.Mrp;
                  let tempItem = {
                    MfgDate: response.Data.ManufacturingDate,
                    ExpiryDate: expiryDate,
                    LifeSpan: product.LifeSpan,
                    Rate: item.Rate,
                    Mrp: item.Mrp,
                    Name: item.ItemName,
                    Weight: item.Quantity,
                    Unit: item.UnitName,
                    Barcode: barcode,
                    BarcodeName: barcode,
                    BatchNo: item.BatchNo,
                    USP:
                      item.UnitName && tempPrice
                        ? item.Quantity
                          ? `${(tempPrice / item.Quantity).toFixed(2)}/${item.UnitName}`
                          : `${tempPrice.toFixed(2)}/${item.UnitName}`
                        : "",
                  };
                  let tempItemToShow = {};
                  barcodeConfig.forEach((config) => {
                    if (config.checked) {
                      tempItemToShow[config.value] = tempItem[config.value];
                    }
                  });
                  tempData.push(tempItemToShow);
                }
              });
              await GetRenderTemplate(tempData, "Variant Template");
              setBarcodeData(tempData);
              if (printButtonRef) {
                printButtonRef.current.click();
              }
            }
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  const deleteManufacturing = async (e) => {
    try {
      let params = {
        ManufacturingId: manufacturingId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeleteManufacturing, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setManufacturingId("");
            setShowDeleteModal(false);
            await fetchManufacturingList(userId, 0);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const GetRenderTemplate = async (Data, Type) => {
    try {
      let paramData = {
        UserId: userId,
        PrintData: Data,
        ConfigurationName: "Manufacturing Barcode",
        Type,
      };
      await api
        .post(APIConstant.path.GetRenderTemplate, paramData)
        .then(async (response) => {
          setTemplateHtml("");
          if (response.Success === 1) {
            setTemplateHtml(response.Html);
            setPrintData1(response.Data);
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const handleOpen = (data = {}, type = "Add") => {
    if (type === "Add") {
      props.history.push("/admin/add-manufacturing");
    } else if (type === "View") {
      props.history.push({
        pathname: "/admin/add-manufacturing",
        state: {
          ManufacturingId: data?._id,
          Type: "View",
        },
      });
    } else if (type === "Edit") {
      props.history.push({
        pathname: "/admin/add-manufacturing",
        state: {
          ManufacturingId: data?._id,
          Type: "Edit",
        },
      });
    } else if (type === "Delete") {
      setShowDeleteModal(true);
      setManufacturingId(data._id);
    } else if (type === "Print") {
      if (barcodeConfig) {
        if (data) {
          GetManufacturingById(data._id);
        } else GetManufacturingById(manufacturingPrintId);
      } else {
        cogoToast.error("Please configure fields in barcode configuration");
      }
    }
  };

  const actionTemplate = (rowData) => (
    <div className="icon-only-btn p-d-flex p-ai-center">
      {userPageAccess?.includes("Print Manufacturing") && (
        <i
          className="pi pi-print"
          onClick={() => handleOpen(rowData, "Print")}
        ></i>
      )}
      {userPageAccess?.includes("Edit Manufacturing") && (
        <i
          className="icon-editImage"
          onClick={() => handleOpen(rowData, "Edit")}
        ></i>
      )}
      {userPageAccess?.includes("View Manufacturing") && (
        <i
          className="icon-view"
          onClick={() => handleOpen(rowData, "View")}
        ></i>
      )}
      {userPageAccess?.includes("Delete Manufacturing") ? (
        <div onClick={(e) => handleOpen(rowData, "Delete")}>
          <i class="icon-delete"></i>{" "}
        </div>
      ) : null}
    </div>
  );

  const onPageChange = (e) => {
    setRowsPerPage(e.rows);
    fetchManufacturingList(userId, e, search);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-arrow-up-right"></i>
          <h2>Manufacturing</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!search ? <i className="icon-search"></i> : null}
          </div>
          {userPageAccess?.includes("Add Manufacturing") ? (
            <div>
              <div className="e-add-btn" onClick={(e) => handleOpen(e, "Add")}>
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      {loading ? <SimpleBackdrop /> : null}
      <DataTable
        className="main-table table-td e-c-table"
        value={manufacturingList}
        paginator
        rows={rowsPerPage}
        totalRecords={totalRecords}
        lazy
        onPage={onPageChange}
        first={first}
        emptyMessage="No records found"
        responsiveLayout="scroll"
        editMode="row"
        dataKey="id"
        rowsPerPageOptions={rowsPerPageOptions}
        globalFilter={search}
        responsive={false}
        resizableColumns={true}
        columnResizeMode="fit"
        scrollable={true}
        scrollWidth="auto"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      >
        <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
        <Column
          field="ManufacturingDate"
          header="Manufacturing Date"
          body={(rowData) =>
            moment(rowData.ManufacturingDate).format("DD/MM/YYYY")
          }
        />

        <Column body={actionTemplate} header="Actions" />
      </DataTable>

      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setManufacturingId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Manufacturing</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setManufacturingId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setManufacturingId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteManufacturing(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <ReactToPrint
        trigger={() => (
          <div className="p-d-none">
            <button ref={printButtonRef}>Print</button>
          </div>
        )}
        content={() => componentRef?.current}
        documentTitle="Manufacturing"
        onAfterPrint={() => {
          setManufacturingData({});
          setBarcodeData([]);
          setManufacturingPrintId("");
        }}
      />

      <div className="p-d-none">
        {/* <div className="im-p-dp details-variant-print" ref={componentRef}>
          <div
            dangerouslySetInnerHTML={{
              __html: templateHtml,
            }}
          />
        </div> */}
      </div>

      <PrintDialog
        open={showPrintDialog}
        onClose={() => setShowPrintDialog(false)}
        templateHtml={templateHtml}
        onPrint={(copies) => zebraWidgetRef.current.onPrint(copies)}
      />

      <ZebraPrinterWidget
        ref={zebraWidgetRef}
        templateData={printData1}
        dpi={203}
      />
    </div>
  );
};

export default Manufacturing;
